import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Helmet from 'react-helmet'
import moment from 'moment'
import MediaQuery from 'react-responsive'
import { Header, HeaderImage } from 'modules/common/components/ui/PageHeader'
import EventPageHeader from 'modules/events/components/EventPageHeader'

import { PageArticle, PageContent, Row }  from 'modules/common/components/grid'
import { H1, H2, H3, H4, DL, UL }  from 'modules/common/components/elements'
import withPro from 'utils/withPro'
import withLocalized from 'modules/localization/withLocalized'
import InlineLoader from 'modules/common/components/inlineloader'

import { formatPlainText } from 'utils/content-utils'
import { formatDateRange } from 'utils/date-utils'
import { formatPrice } from 'utils/price-utils'

import { getSeoForPage } from 'modules/seo'


const ProHeader = withPro(withLocalized(EventPageHeader))

const PriceList = ({id, items, currency, location = {}, localeConfig}) => {
  const {
    pathname,
    state,
  } = location
  return (
    <UL plain>
      { items.map(({id: priceId, price_label, price_value}) => (
        <li key={priceId} className="item__margin-bottom"><Link
          className="btn btn--wider btn--price"
          to={{
            pathname: priceId ? `/events/${id}/book/${priceId}` : `/events/${id}/book`,
            state: {
              modal: true,
              prevUrl: pathname,
              prevState: state
            }
          }}
        >
            {price_label}{" "}
            {formatPrice(
              price_value,
              currency,
              localeConfig("units.currency.locale")
            )}
        </Link></li>
      )
    )}
    </UL>
  )
}

class EventPage extends Component {
  componentWillMount() {
    this.loadData();
  }

  loadData() {
    const { id, loadEvent } = this.props
    loadEvent(id)
  }

  scrollToProduct = (event) => {
    event.preventDefault()
    if (!this.product) return;
    this.product.scrollIntoView({ block: 'start', behavior: 'smooth', inline: 'start' })
  };

  render() {
    const {
      event,
      localized,
      localeConfig,
      canBeBooked,
      location,
      imageSrc,
      imageSrcDesktop
    } = this.props

    if (!event) return <InlineLoader />

    const {
      id,
      title,
      date_from,
      date_to,
      description,
      place,
      pro = [{ label: '', id: undefined }],
      price,
      prices,
      schedule,
      participants_count,
      participants_max,
      currency = localeConfig("units.currency.identifier")
    } = event;

    const formattedDates = formatDateRange(moment(date_from), moment(date_to));
   
    const priceList = prices && prices.length ? prices : undefined;

    const seoData = getSeoForPage("custom", {
      title: title,
      description: description,
      image: imageSrcDesktop
    });


    return (
      <div className="full-height">
        <Helmet title={seoData.title} meta={seoData.meta} />
        <Header stripe>
          <MediaQuery maxWidth={767}>
            <HeaderImage src={imageSrc} noOverlay />
          </MediaQuery>
          <MediaQuery minWidth={768}>
            <HeaderImage src={imageSrcDesktop} noOverlay />
          </MediaQuery>
        </Header>
        <PageArticle>
          <Row>
            { pro.map(({id}) => id && <ProHeader scrollToProduct={this.scrollToProduct} key={id} id={id} />) }
            <PageContent id="page-content" className="content--page">
              <article ref={el => this.product = el}>
                <header>
                  <H1 bigger regular halfMarginBottom>{title}</H1>
                </header>
                <H3 noTopMargin>{`${formattedDates} - ${pro[0].label}, ${place}`}</H3>
                <div
                  dangerouslySetInnerHTML={{
                    __html: formatPlainText(description)
                  }}
                />
                <H2 doubleTopMargin>{localized("event.title_schedule")}</H2>
                {schedule.map(({id, label, description}) => {
                  return (
                    <div key={id}>
                      <H4 noMargin>{label}</H4>
                      <div dangerouslySetInnerHTML={{
                        __html: formatPlainText(description, false)
                      }}
                      />
                    </div>
                  );
                })}
                <H2 doubleTopMargin>{localized("event.title_participants")}</H2>
                <DL>
                  <dt>Group size</dt>
                  <dd>{participants_max}</dd>
                  <dt>Bookings</dt>
                  <dd>{participants_count}</dd>
                </DL>
                <H2 doubleTopMargin>{localized("event.title_make_reservation")}</H2>
                <p>{localized("event.label_reservation_help")}</p>
                { !canBeBooked && <p>{localized("event.fullybooked")}</p> }
                { (canBeBooked && priceList) && <PriceList location={location} id={id} currency={currency} items={priceList} localeConfig={localeConfig} /> }
                { (canBeBooked && !priceList && price) && <PriceList location={location} id={undefined} currency={currency} items={[price]} localeConfig={localeConfig} /> }
              </article>
            </PageContent>
          </Row>
        </PageArticle>
      </div>
    );
  }
}

export default EventPage



// WEBPACK FOOTER //
// ./src/modules/events/components/EventPage.js